<template>
  <b-modal
    id="modalTaskDelete"
    ref="modalTaskDelete"
    :no-enforce-focus="true"
    size="lg"
    @hidden="onHidden"
  >
    <div slot="modal-title">
      <i class="fas fa-exclamation-triangle text-warning mr-2" />
      {{ 'WARNING' | translate }}
    </div>

    <p class="mb-3">
      {{ 'WARNING: deleting an activity is an irreversible operation. Do you want to continue?' | translate }}
    </p>

    <template v-if="hasSubtasks">
      <p class="mb-3">
        {{ 'The activity also has sub-activities. By continuing, these will be deleted as well' | translate }}
      </p>
      <table v-if="subtasks.length" class="table table-sm mb-0">
        <thead>
          <tr>
            <th>{{ 'Activity' | translate }}</th>
            <th>{{ 'Customer' | translate }}</th>
            <th>{{ 'Assignees' | translate }}</th>
            <th>{{ 'State' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="subtask in subtasks" :key="subtask.id">
            <td class="text-wrap">{{ subtask.name }}</td>
            <td class="text-wrap">{{ subtask.customer_name }}</td>
            <td class="text-wrap text-uppercase">{{ subtask.assignee_names }}</td>
            <td>
              <span
                v-if="subtask.state_name"
                class="badge"
                :style="{ backgroundColor: subtask.state_color || '#6c757d', color: '#fff' }"
              >
                {{ subtask.state_name }}
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </template>

    <div slot="modal-footer">
      <b-btn class="mr-2" variant="default" @click="close">
        {{ 'Cancel' | translate }}
      </b-btn>
      <b-btn variant="danger" @click="onConfirm">
        <i class="fas fa-trash mr-2" />
        {{ 'Delete' | translate }}
      </b-btn>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'TaskDeleteModal',
  props: {
    task: { required: true },
    // Sottoattività già disponibili (es. cache della tabella). Per ora non si
    // fa alcuna chiamata: l'eventuale fetch verrà collegata in seguito.
    subtasks: { type: Array, default: () => [] }
  },
  computed: {
    hasSubtasks () {
      return !!(this.task && (this.task.has_children || this.subtasks.length))
    }
  },
  mounted () {
    this.$refs.modalTaskDelete.show()
  },
  methods: {
    onConfirm () {
      // TODO: azione di eliminazione da collegare in seguito.
      this.$emit('confirm', this.task)
      this.close()
    },
    close () {
      this.$refs.modalTaskDelete.hide()
    },
    onHidden () {
      this.$emit('close')
    }
  }
}
</script>
